/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./script-loader.component";
var styles_ScriptLoaderComponent = [];
var RenderType_ScriptLoaderComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_ScriptLoaderComponent, data: {} });
export { RenderType_ScriptLoaderComponent as RenderType_ScriptLoaderComponent };
export function View_ScriptLoaderComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_ScriptLoaderComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "script-loader", [], null, null, null, View_ScriptLoaderComponent_0, RenderType_ScriptLoaderComponent)), i0.ɵdid(1, 114688, null, 0, i1.ScriptLoaderComponent, [i0.Renderer2, i0.ElementRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ScriptLoaderComponentNgFactory = i0.ɵccf("script-loader", i1.ScriptLoaderComponent, View_ScriptLoaderComponent_Host_0, { src: "src" }, {}, []);
export { ScriptLoaderComponentNgFactory as ScriptLoaderComponentNgFactory };
